import { useCallback } from 'react';

import { useClient } from 'urql';

import { useSetupIntent } from '../useSetupIntent';
import {
  CustomerSessionDocument,
  CustomerSessionQuery,
  useCustomerSessionQuery,
} from './graphql/CustomerSession.generated';

export const useCustomerSession = () => {
  const client = useClient();
  const [response, refetchCustomerSession] = useCustomerSessionQuery({
    requestPolicy: 'network-only',
  });

  const customerId = response.data?.customerPaymentInfo?.id;
  const customerSessionClientSecret = response.data?.customerPaymentInfo?.paymentSessionId; // prettier-ignore
  const hasCustomerSessionError = Boolean(response.error);

  const {
    setupIntentSecret,
    refetchSetupIntent,
    hasError: hasSetupIntentError,
  } = useSetupIntent(!customerId);

  const refetch = useCallback(() => {
    refetchCustomerSession({ requestPolicy: 'network-only' });
    if (customerId) void refetchSetupIntent({});
  }, [customerId, refetchCustomerSession, refetchSetupIntent]);

  const fetchCustomerSessionSecret = useCallback(async () => {
    const response = await client
      .query<CustomerSessionQuery>(CustomerSessionDocument, { requestPolicy: 'network-only' })
      .toPromise();

    return response.data?.customerPaymentInfo?.paymentSessionId;
  }, [client]);

  const isFetching = !customerSessionClientSecret || !setupIntentSecret;
  const hasError = hasCustomerSessionError || hasSetupIntentError;

  return {
    customerId,
    customerSessionClientSecret,
    setupIntentSecret,
    isFetching,
    hasError,
    refetch,
    fetchCustomerSessionSecret,
  };
};
